import Image from 'next/image'
import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { IconInfo } from '@redteclab/icons'

import { Button } from 'base-ui'

import { useGlobalConfigContext } from '../../../global-config'
import { urlResolverGetRedeemPrescription } from '../../../url-handling'

import illustrationUnknownLocation from './illustration-unknown-location.png'

export const ProductPageOdsDialogLocalDoctorTabsPanel: FC = () => {
  const intl = useIntl()
  const globalConfig = useGlobalConfigContext()

  return (
    <section id="local-doctor">
      <Image
        alt={intl.formatMessage({
          id: 'pdp.buyboxwithvariants.odsModal.tabs.tab2.title',
        })}
        className="mx-auto mb-5 shrink-0"
        height={96}
        src={illustrationUnknownLocation}
        unoptimized
        width={108}
      />
      <h2 className="mb-5 text-l">
        <FormattedMessage id="pdp.buyboxwithvariants.odsModal.tabs.localDoctor.heading" />
      </h2>
      <p className="text-dark-primary-strong">
        <FormattedMessage id="pdp.buyboxwithvariants.odsModal.tabs.localDoctor.description" />
      </p>

      <Button<'a'>
        className="mt-2.5"
        href={urlResolverGetRedeemPrescription(globalConfig)}
        size="medium"
        slots={{ root: 'a' }}
        startIcon={<IconInfo />}
        variant="text"
      >
        <FormattedMessage id="account.orders.details.collapsible.label.information" />
      </Button>
    </section>
  )
}
